<template>
  <content-box class="encourage-plan--wrap" :class="{ 'is-layer': isLayer }" :width="'770px'">
    <h2><i class="icon icon--logo-new"></i></h2>
    <template v-if="dashboardState === 'firstLogin'">
      <p class="title" v-html="$t('dashboard.encouragePlan.default.title')"></p>
      <ui-button class="btn__confirm"
        :backgroundColor="'#ec0047'"
        :primary="true"
        :size="'large'"
        @click="$emit('onCloseLayer')">{{ $t('dashboard.encouragePlan.default.button') }}</ui-button>
      <p class="desc" v-html="$t('dashboard.encouragePlan.default.desc')"></p>
    </template>
    <template v-else-if="dashboardState === 'noPage-plan-noCredit'">
      <p class="title">{{ $t('dashboard.encouragePlan.creditEmpty.title') }}</p>
      <p class="desc2" v-html="$t('dashboard.encouragePlan.creditEmpty.desc')"></p>
      <div class="btn__wrap">
        <ui-button :backgroundColor="'#ec0047'"
                   :primary="true"
                   @click="$router.push({ name: 'managePlan', params: { action: 'changePlan' } })">
          {{ $t('common.upgradePlan') }}
        </ui-button>
        <ui-button :backgroundColor="'#1199af'"
                   :primary4="true"
                   :iconName="'icon--pv-plug'"
                   :disabled="$i18n.locale === 'ja'"
                   @click="$router.push({ name: 'managePlan', params: { action: 'chargePv' } })">
          {{ $t('common.chargePv') }}
        </ui-button>
      </div>
    </template>
    <template v-else-if="dashboardState === 'noPage-noPlan'">
      <p class="title" v-html="$t('dashboard.encouragePlan.noPlan.title')"></p>
      <ui-button class="btn__confirm"
        :backgroundColor="'#ec0047'"
        :primary="true"
        :size="'large'"
        @click="$router.push({ name: 'managePlan', params: { action: 'createPlan' } })">
        {{ $t('common.subscribeYourPlan') }}
      </ui-button>
    </template>
    <div class="carousel--wrap">
      <div class="swiper-container">
        <div class="swiper-wrapper"
             :class="{isDragging}"
             :style="{left: slidePosition}"
             ref="slides"
             @mousedown="onHandleStart"
             @touchstart="onHandleStart"
        >
          <div class="list1 swiper-slide" :class="{ active: currentIndex === 0 }">
            <!-- spec out
            <a href="" target="_blank" class="move-guide">
              {{ $t('common.registrationGuide') }}
              <i class="icon icon--link-size16"></i>
            </a>
            -->
            <div class="carousel__content">
              <figure class="content__img" :class="$i18n.locale">
              </figure>
              <div class="content__desc">
                <p class="title" v-html="$t('dashboard.encouragePlan.pagination.step1.title')"></p>
                <p class="desc" v-html="$t('dashboard.encouragePlan.pagination.step1.desc')"></p>
              </div>
            </div>
          </div>
          <div class="list2 swiper-slide" :class="{ active: currentIndex === 1 }">
            <!-- spec out
            <a href="" target="_blank" class="move-guide">
              {{ $t('common.trackingCodeInstallationGuide') }}
              <i class="icon icon--link-size16"></i>
            </a>
            -->
            <div class="carousel__content">
              <figure class="content__img" :class="$i18n.locale">
              </figure>
              <div class="content__desc">
                <p class="title">{{ $t('dashboard.encouragePlan.pagination.step2.title') }}</p>
                <p class="desc" v-html="$t('dashboard.encouragePlan.pagination.step2.desc')"></p>
              </div>
            </div>
          </div>
          <div class="list3 swiper-slide" :class="{ active: currentIndex === 2 }">
            <div class="carousel__content">
              <figure class="content__img" :class="$i18n.locale">
              </figure>
              <div class="content__desc">
                <p class="title">{{ $t('dashboard.encouragePlan.pagination.step3.title') }}</p>
                <p class="desc" v-html="$t('dashboard.encouragePlan.pagination.step3.desc')"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination" slot="pagination" ref="pagination">
          <template v-for="index in slides.length">
            <span
              :key="index"
              class="dot"
              :class="{ active: index - 1 === currentIndex }"
              @click="goToSlide(index - 1)"
            ></span>
          </template>
        </div>
        <div v-show="!isFirstSlide"
             ref="swiperLeft"
             class="swiper-button-prev icon icon--prev-white-size20"
             @click="prevSlide"
        ></div>
        <div v-show="!isLastSlide"
             ref="swiperRight"
             class="swiper-button-next icon icon--prev-white-size20"
             @click="nextSlide"
        ></div>
      </div>
    </div>
    <i v-if="isLayer" class="icon icon--close-btn" @click="$emit('onCloseLayer')"></i>
  </content-box>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import ContentBox from '@/components/ui/ContentBox'

export default {
  components: {
    UiButton,
    ContentBox
  },
  props: [
    'dashboardState'
  ],
  data () {
    return {
      slides: [],
      currentIndex: 0,
      slideInterval: null,
      isDragging: false,
      startX: 0,
      endX: 0,
      dragOffset: 0,
      slidePosition: null
    }
  },
  computed: {
    isLayer () {
      return this.dashboardState === 'firstLogin'
    },
    isFirstSlide () {
      return this.currentIndex === 0
    },
    isLastSlide () {
      if (this.slides) {
        return this.currentIndex === this.slides.length - 1
      }
      return false
    }
  },
  mounted () {
    this.slides = document.querySelectorAll('.swiper-slide')

    this.startAutoSlide()
  },
  beforeDestroy () {
    this.stopAutoSlide()
  },
  methods: {
    nextSlide () {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
      this.getTransformStyle()
    },
    prevSlide () {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length
      this.getTransformStyle()
    },
    goToSlide (index) {
      this.currentIndex = index
      this.getTransformStyle()
    },
    onHandleStart (event) {
      this.isDragging = true
      this.startX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = 0
      if (this.isDragging) {
        window.addEventListener('mousemove', this.onHandleMove)
        window.addEventListener('mouseup', this.onHandleEnd)
      }
      this.stopAutoSlide()
    },
    onHandleMove (event) {
      if (!this.isDragging) return

      const currentX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = currentX - this.startX
      const dragTranslate = (this.dragOffset / 710) * 100
      const baseTranslate = -this.currentIndex * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    onHandleEnd () {
      if (!this.isDragging) return

      if (this.dragOffset > 50) {
        this.prevSlide()
      } else if (this.dragOffset < -50) {
        this.nextSlide()
      } else {
        this.resetDrag()
      }
      this.isDragging = false
      this.startX = 0
      this.endX = 0
      this.getTransformStyle()
      this.startAutoSlide()
    },
    getTransformStyle () {
      const baseTranslate = -this.currentIndex * 100
      const dragTranslate = (this.endX / 710) * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    resetDrag () {
      this.dragOffset = 0
    },
    startAutoSlide () {
      this.slideInterval = setInterval(() => {
        this.nextSlide()
      }, 5000)
    },
    stopAutoSlide () {
      if (this.slideInterval) {
        clearInterval(this.slideInterval)
        this.slideInterval = null
      }
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.encourage-plan--wrap {
  padding: 30px;
  box-sizing: border-box;
  @include positionXYcenter;

  .icon--close-btn {
    position: absolute;
    top: 0;
    right: 0;
    padding: 12px;
    background-position: center;
  }

  & > .title {
    margin-top: 48px;
    font-size: 36px;
    font-weight: 600;
    color: #555555;
    line-height: 1.33;
    text-align: center;
  }

  & > .desc {
    margin-top: 10px;
    text-align: center;
    font-size: 14px;
    color: $brandColor;
  }

  & > .desc2 {
    text-align: center;
    margin-top: 10px;
    padding-left: 10px;
    font-size: 24px;
    color: #555;
  }

  .btn__confirm {
    display: block;
    margin: 30px auto 0;
  }

  .btn__wrap {
    display: block;
    margin: 30px auto 0;
    text-align: center;

    button {
      margin: 0 2.5px;
    }
  }

  .carousel--wrap {
    @include carouselContent;
    margin-top: 20px;
    width: 100%;
    height: 300px;
    border-radius: 5px;
    background-color: #2f2f2f;

    .swiper-wrapper {
      position: relative;
      transition: left 0.3s ease;

      &.isDragging {
        transition: initial;
      }
    }

    /deep/ .swiper-slide {
      -webkit-user-select:none;
      -moz-user-select:none;
      -ms-user-select:none;
      user-select:none;

      .content__img {
        width: 288px;
        height: 180px;
        background-size: cover;
      }
    }

    .list1 {
      .content__img {
        &.ko {
          background-image: url(../../assets/img/dashboard/free_trial_ko1.png);
        }
        &.ja {
          background-image: url(../../assets/img/dashboard/free_trial_ja1.png);
        }
        &.en {
          background-image: url(../../assets/img/dashboard/free_trial_en1.png);
        }
      }
    }

    .list2 {
      .content__img {
        &.ko {
          background-image: url(../../assets/img/dashboard/free_trial_ko2.png);
        }
        &.ja {
          background-image: url(../../assets/img/dashboard/free_trial_ja2.png);
        }
        &.en {
          background-image: url(../../assets/img/dashboard/free_trial_en2.png);
        }
      }
    }

    .list3 {
      .content__img {
        &.ko {
          background-image: url(../../assets/img/dashboard/free_trial_ko3.png);
        }
        &.ja {
          background-image: url(../../assets/img/dashboard/free_trial_ja3.png);
        }
        &.en {
          background-image: url(../../assets/img/dashboard/free_trial_en3.png);
        }
      }
    }

    .move-guide {
      position: absolute;
      top: 15px;
      right: 15px;
      font-size: 13px;
      font-weight: 600;
      line-height: 1;
      color: #d7d7d7;
      .icon {
        transform: rotateY(180deg) translateY(-2px);
        vertical-align: text-bottom;
        margin-left: 5px;
      }
    }

    .carousel__content {
      @include flexXcenter;
      padding-top: 59px;

      .content__img {
        margin-right: 40px;
      }

      .content__desc {
        width: 270px;
        white-space: normal;
        .title {
          margin-top: 18px;
          font-size: 18px;
          font-weight: 600;
          color: #ffffff;
          white-space: nowrap;
        }
        .desc {
          margin-top: 20px;
          font-size: 14px;
          line-height: 1.5;
          color: #d7d7d7;
        }
      }
    }
    .swiper-pagination {
      display: flex;
      position: absolute;
      bottom: 3%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;

      .dot {
        width: 8px;
        height: 8px;
        background-color: rgba(255, 255, 255, 0.35);
        border-radius: 100%;
        margin: 0 5px;
        cursor: pointer;
        display: flex;
        transition: all .3s;

        &.active {
          background: #FFF;
        }

        &:hover {
          background-color: #aaa;
        }
      }
    }

  }
}
</style>
